<template>
  <!-- 招聘 -->
  <div>
    <el-form
      ref="offerForm"
      label-position="left"
      :model="offerForm"
      :rules="offerRules"
      label-width="115px"
      class="news"
    >
      <h2>{{ $t("join.application") }}</h2>
      <el-form-item :label="$t('join.applicantName')" prop="applicantName">
        <el-input v-model="offerForm.applicantName" maxlength="32"></el-input>
      </el-form-item>
      <el-form-item :label="$t('join.gender')">
        <el-select v-model="offerForm.gender">
          <el-option :label="$t('join.male')" :value="0"></el-option>
          <el-option :label="$t('join.female')" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('join.birthday')" prop="birthday">
        <el-date-picker
          type="date"
          v-model="offerForm.birthday"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('join.mobile')" prop="mobile">
        <el-input v-model="offerForm.mobile" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item :label="$t('join.email')" prop="email">
        <el-input v-model="offerForm.email" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item :label="$t('join.education')" prop="education">
        <el-select v-model="offerForm.education">
          <el-option :label="$t('join.specialist')" :value="1"></el-option>
          <el-option :label="$t('join.undergraduate')" :value="2"></el-option>
          <el-option :label="$t('join.master')" :value="3"></el-option>
          <el-option :label="$t('join.doctor')" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('join.academy')" prop="academy">
        <el-input v-model="offerForm.academy" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item :label="$t('join.city')" prop="city">
        <el-input v-model="offerForm.city" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item :label="$t('join.clinicalExperience')">
        <el-select v-model="offerForm.clinicalExperience">
          <el-option :label="$t('join.no')" :value="0"></el-option>
          <el-option :label="$t('join.yes')" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('join.file')" prop="file">
        <el-upload
          class="upload-demo"
          action=""
          accept=".pdf"
          :on-change="handleChange"
          :before-remove="beforeRemove"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="offerForm.file"
          :auto-upload="false"
        >
          <el-button size="small" type="primary">{{
            $t("join.selectFile")
          }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ $t("join.desc") }}</div>
        </el-upload>
      </el-form-item>
      <div class="news btn-submit">
        <el-button type="primary" :loading="loading" @click="onSubmit('offerForm')">{{
          $t("join.submit")
        }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { PostApplicantInfo } from "../../api/web";

export default {
  name: "join",
  data() {
    const validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      offerForm: {
        applicantName: "",
        gender: 0,
        birthday: "",
        mobile: "",
        email: "",
        education: "",
        academy: "",
        clinicalExperience: 0,
        city: "",
        file: [],
      },
      offerRules: {
        applicantName: [{ required: true, message: " ", trigger: "blur" }],
        birthday: [
          { type: "date", required: true, message: " ", trigger: "change" },
        ],
        jobRequirements: [{ required: true, message: " ", trigger: "blur" }],
        mobile: [{ required: true, validator: validatorPhone, message: " ", trigger: "blur" }],
        email: [{ type: 'email', required: true, message: " ", trigger: "blur" }],
        education: [{ required: true, message: " ", trigger: "blur" }],
        academy: [{ required: true, message: " ", trigger: "blur" }],
        city: [{ required: true, message: " ", trigger: "blur" }],
        file: [{ required: true, message: " ", trigger: "change" }],
      },
    };
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        this.loading = true
        if (valid) {
          this.offerForm.companyId = this.companyId;
          this.offerForm.positionId = this.positionId;
          let params = new FormData();
          for (const key in this.offerForm) {
            if (Object.hasOwnProperty.call(this.offerForm, key)) {
              const element = this.offerForm[key];
              params.set(key, key === "file" ? element[0].raw : element);
            }
          }
          PostApplicantInfo(params).then((res) => {
            if (res.status) {
              this.$message.success("提交成功");
              this.loading = false;
              this.$router.push({
                name: "COMPANY",
              });
              this.loading = false;
            }
          });
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    handleChange(file, fileList) {
      this.offerForm.file = fileList;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
  computed: {
    positionId() {
      return this.$route.query.positionId;
    },
    companyId() {
      return this.$route.query.companyId;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/constant";
.news {
  width: 792px;
  margin: 0 auto;
  padding: 30px 10px;
}
.btn-submit {
  text-align: center;
}
@media screen and (max-width: 996px) {
  h2 {
    font-size: 25px !important;
  }
}
</style>